module.exports = __webpack_public_path__ + "img/whats.9b0c66e3.svg";